/* eslint-disable react/prop-types */
import './SortableLabelFieldEditor.scss';

import React from 'react';
import PropTypes from 'prop-types';

import SortableList, { SortableItem, SortableKnob } from 'react-easy-sort';
import { TrashIcon, MoveIcon, GearIcon, VideoIcon } from '@radix-ui/react-icons';
import Logger from '@KrashidBuilt/common/utils/logger';

import { TEMPLATE_FIELD_TYPES } from '../../constants';
import { FieldSelect, FieldTypeSelect } from '..'; // components

const logger = new Logger(__filename);

const ROW_AMOUNT = 5;

const FieldContainer = ({ selection, index, removeField, onFieldTypeChange, obscured }) => (
    <div className={`FieldContainer${obscured ? ' Obscured' : ''}`}>

        {logger.extra({ selection, index, removeField, onFieldTypeChange, obscured })}

        <SortableKnob>
            <div className='MoveIcon'>
                <MoveIcon />
            </div>
        </SortableKnob>

        <div className={'FieldLabel'}>
            {/* [JOB] - JOB NAME */}
            {/* remove category label "[JOB] - " */}
            {selection.label?.split('] - ').pop()}
            {/* JOB NAME */}
        </div>

        <div className={'FieldType'}>
            <FieldTypeSelect
                // if this index is a multiple of 5 (5 fields per row)
                options={index % ROW_AMOUNT === 0 ? TEMPLATE_FIELD_TYPES : TEMPLATE_FIELD_TYPES.filter((ft) => ft?.value != 'qr')}
                onChange={(o) => {
                    onFieldTypeChange(index, o);
                }}
                value={TEMPLATE_FIELD_TYPES.find((t) => t.value === selection.type)}
            />
        </div>

        {/* eslint-disable-next-line */}{/* yea im able-ist come at me bro */}
        <div className='TrashLabel' onClick={() => removeField(selection)}>
            <TrashIcon color='red' />
        </div>

    </div>
);

FieldContainer.defaultProps = {
};

FieldContainer.propTypes = {
    selection: PropTypes.shape(),
    index: PropTypes.num,
    removeField: PropTypes.func,
    onFieldTypeChange: PropTypes.func,
    obscured: PropTypes.bool
};

const AddFieldButton = ({ selected, options, addField, obscured }) => {
    // remove from already selected fields from options 
    const filteredOptions = options.filter((o) => !selected?.some((s) => o.value === s.value && o.label === s.label));

    return (
        <div className={`FieldContainer Add${obscured ? ' Obscured' : ''}`}>
            <div className='AddLabel'>
                <FieldSelect
                    options={filteredOptions}
                    onChange={(e) => addField(e)}
                    value={null} // just want the drop down lol
                />
            </div>
        </div>
    );
};

AddFieldButton.defaultProps = {
};

AddFieldButton.propTypes = {
    selection: PropTypes.object,
    options: PropTypes.object,
    addField: PropTypes.func,
    obscured: PropTypes.bool
};

const obscuredByQrCode = (selected, index) => {
    const section = Math.floor(index / ROW_AMOUNT);
    const sectionFloor = section * ROW_AMOUNT;
    const sectionCeiling = (section + 1) * ROW_AMOUNT;

    // if the first value of a section is a qr code
    if (selected[sectionFloor]?.type == 'qr') {
        // check if this field is in that section
        if (index > sectionFloor && index < sectionCeiling) {
            return true;
        }
    }

    return false;
};

const SortableLabelFieldEditor = (props) => {
    const { selected, onSortEnd, title = 'LABEL FIELDS', fieldCount = 10 } = props;

    return (
        <div>

            <strong>{title}</strong>

            <SortableList className='Grid' onSortEnd={onSortEnd}>
                {selected.map((selection, index) => (
                    <SortableItem key={selection?.value}>
                        <div>
                            {/* passing in map params with the props 👇  */}
                            <FieldContainer {...{ ...props, selection, index, obscured: obscuredByQrCode(selected, index, fieldCount) }} />
                        </div>
                    </SortableItem>
                ))}
                {(selected?.length < fieldCount) &&
                    <AddFieldButton {...{ ...props }} /> // passes in props
                }
            </SortableList>

            <div className='Key'>
                <p>
                    <span className='KeyItem'><MoveIcon /> Move</span>
                    <span className='KeyItem'><GearIcon /> Change</span>
                    <span className='KeyItem'><TrashIcon color='red' /> Delete</span>
                    <a href='https://www.youtube.com/watch?v=rLjdFh1UUQg' target='_blank' rel="noreferrer"><span className='KeyItem'>< VideoIcon /> Watch Demo</span></a>
                </p>
            </div>

        </div>
    );
};

SortableLabelFieldEditor.defaultProps = {
};

SortableLabelFieldEditor.propTypes = {
    selection: PropTypes.shape(),
    index: PropTypes.number,
    removeField: PropTypes.func,
    onFieldTypeChange: PropTypes.func,
    obscured: PropTypes.bool
};

export default SortableLabelFieldEditor;